export const pl = {
  header: {
    title: 'Propertly.io Agent Głosowy',
    subtitle: 'Doświadcz Rozmów AI w Nieruchomościach',
  },
  hero: {
    badge: 'Wypróbuj teraz',
    title: 'Zadzwonimy do Ciebie za 10 sekund',
    subtitle: 'Nie wyobrażaj sobie jak to działa. Doświadcz tego.',
    description: 'To prawdziwe połączenie systemowe na Twój telefon.',
  },
  howItWorks: {
    title: 'Jak działa to demo:',
    step1: {
      number: '1',
      title: 'Wypełnij formularz poniżej',
      description: 'Wpisz nazwę swojego biura i numer telefonu (zadzwonimy w mniej niż 10 sekund)',
    },
    step2: {
      number: '2',
      title: 'Dzwonimy natychmiast',
      description: 'Nasz system przywita Cię jako recepcja Twojego biura',
    },
    step3: {
      number: '3',
      title: 'Zachowuj się jak klient',
      description: 'Udawaj kupującego zainteresowanego nieruchomością lub sprzedającego z domem do sprzedania',
    },
  },
  form: {
    businessName: {
      label: 'Nazwa Twojego Biura',
      placeholder: 'Acme Nieruchomości',
      hint: 'System odbierze telefon tą nazwą: "Dziękujemy za telefon do [Twoje Biuro]"',
    },
    firstName: {
      label: 'Twoje Imię',
      placeholder: 'Anna',
    },
    lastName: {
      label: 'Twoje Nazwisko',
      placeholder: 'Kowalska',
      hint: 'System będzie zwracać się do Ciebie po imieniu podczas rozmowy',
    },
    email: {
      label: 'Twój Email',
      placeholder: 'anna@firma.pl',
      hint: 'Wyślemy Ci transkrypcję rozmowy i podsumowanie po demo',
    },
    intent: {
      label: 'Jak chcesz przetestować system?',
      placeholder: 'Wybierz jak będziesz się zachowywać podczas rozmowy',
      hint: 'Będziesz udawać kupującego lub sprzedającego podczas demo',
      options: {
        buy: 'Kupuję',
        sell: 'Sprzedaję',
      },
    },
    selectedListing: {
      label: 'Którą nieruchomość Cię "interesuje"?',
      placeholder: 'Wybierz nieruchomość do zapytania',
      hint: 'Gdy system zapyta czego szukasz, wspomnij tę nieruchomość',
    },
    location: {
      label: 'Gdzie znajduje się Twoja nieruchomość?',
      wojewodztwo: {
        label: 'Województwo',
        placeholder: 'Wybierz województwo',
      },
      city: {
        label: 'Miasto',
        placeholder: 'Warszawa',
        optional: '(opcjonalnie)',
      },
      hint: 'Powiedz systemowi o tej lokalizacji, gdy zapyta o Twoją nieruchomość',
    },
    phone: {
      label: 'Twój Numer Telefonu',
      placeholder: '+48 123 456 789',
      hint: 'Zadzwonimy na ten numer w mniej niż 10 sekund',
    },
    consent: {
      label: 'Zgadzam się na otrzymanie demonstracyjnego połączenia od Propertly.io na podany numer.',
    },
    submit: 'Zadzwoń do Mnie Teraz',
    submitting: 'Dzwonimy...',
    disclaimer: 'Bez zobowiązań. Bez karty kredytowej. Tylko 2-minutowe demo na Twój telefon.',
  },
  success: {
    badge: 'Połączenie w toku',
    title: 'Dzwonimy do Ciebie teraz.',
    description: 'Nasz asystent AI przywita Cię jako Twoje biuro i poprowadzi rozmowę.',
    reset: 'Poproś o kolejne połączenie',
  },
  footer: {
    copyright: '© 2024 Propertly.io - Napędzane przez Technologię Głosu AI',
    privacy: 'Polityka Prywatności',
    terms: 'Warunki Świadczenia Usług',
  },
};
